/**
 * Field set for read-only (published/shared) urlMeta rendering — mirrors
 * QUOTED_URL_META_FIELDS's coverage (article/gallery/media fields, not just
 * title/description/image) so published pages stop under-fetching what the
 * in-app view already has. Deliberately excludes `embed` (raw HTML +
 * third-party <script src> injection) — loading arbitrary remote scripts on
 * an anonymous public page is a real XSS/supply-chain risk that the
 * authenticated in-app context doesn't carry the same way; skip until that
 * gets a deliberate design pass, not an oversight.
 */
export const READ_ONLY_URL_META_FIELDS = `
    urlMeta {
        author
        date
        description
        article_url
        article_body
        image
        image_asset_id
        gallery_images
        gallery {
            type
            image
            image_name
            image_asset_id
            media_asset_id
            width
            height
            aspect_ratio
            media_url
            media_cdn_url
            media_hls_url
            media_duration
            media_has_audio
            media {
                public_id
                url
                cdn_url
                name
                displayName
                type
                format
                size
                aspect_ratio
                width
                height
                mime
                duration
                ocrText
                ocrExtracted
            }
        }
        image_cdn_url
        public_id
        image_name
        width
        height
        format
        aspect_ratio
        size
        thumbnail {
            sm
            md
            lg
            xl
            original
            compressed {
                sm
                md
                lg
                xl
                original
            }
        }
        media_url
        media_asset_id
        media_audio_asset_id
        media_cdn_url
        media_type
        media_width
        media_height
        media_duration
        media_has_audio
        media_hls_url
        logo
        publisher
        title
        url
        author_image
        author_image_cdn_url
        author_image_public_id
        author_image_name
        author_image_size
        author_image_format
        author_image_aspect_ratio
        author_image_width
        author_image_height
        author_image_original
        author_image_thumbnail {
            sm
            md
            lg
            xl
            original
            compressed {
                sm
                md
                lg
                xl
                original
            }
        }
    }
`;
